import { inputTypes } from "data/globalData";

export const fabricRoleColumn = {
	name: "Fabric Role",
	key: "fabric_role",
};
export const fabricConsumptionColumns = {
	consumption: { name: "Consumption", key: "consumption", input_type: inputTypes.ENTER.key },
	consumption_unit: { name: "Consumption Unit", key: "consumption_unit", input_type: inputTypes.SELECT.key },
};
